module.exports = {
          srcSet: __webpack_public_path__ + "99586c334166962424311d0b7c57a071-50.png"+" 50w",
          images:[ {path: __webpack_public_path__ + "99586c334166962424311d0b7c57a071-50.png",width: 50,height: 49}],
          src: __webpack_public_path__ + "99586c334166962424311d0b7c57a071-50.png",
          toString:function(){return __webpack_public_path__ + "99586c334166962424311d0b7c57a071-50.png"},
          
          width: 50,
          height: 49
        }